import { CircularProgress, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import api from '../../api/base';
import { activateUserEp } from '../../api/paths';
import { useQuery } from '../../hooks/useQuery';
import { ActivateUserWrapper } from './ActivateUser.styled';

const ActivateUser = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [success, setSuccess] = useState<boolean>(true);
  const [errorMessage, setErrorMessage] = useState<string>('');

  const query = useQuery();

  const activateMobileUser = async () => {
    const uid = query.get('uid');
    const token = query.get('token');

    try {
      await api.post(activateUserEp, { uid, token });
    } catch (error: any) {
      const err = error.response?.data?.detail;

      setErrorMessage(err || 'Something went wrong with activation');
      setSuccess(false);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    activateMobileUser();
  }, []);

  return (
    <ActivateUserWrapper>
      {isLoading
        ? (
          <CircularProgress />
        )
        : (
          <Typography variant="txl" color="primary.400">
            {success ? 'User has been activated successfully' : errorMessage}
          </Typography>
        )}
    </ActivateUserWrapper>
  );
};

export default ActivateUser;
